export var OutlineColor;
(function (OutlineColor) {
    OutlineColor["BLUE"] = "blue";
    OutlineColor["YELLOW"] = "yellow";
    OutlineColor["RED"] = "red";
    OutlineColor["ORANGE"] = "orange";
    OutlineColor["BLACK"] = "black";
})(OutlineColor || (OutlineColor = {}));
export var AlbedoColor;
(function (AlbedoColor) {
    AlbedoColor["RED"] = "red";
    AlbedoColor["NONE"] = "none";
})(AlbedoColor || (AlbedoColor = {}));
//# sourceMappingURL=SceneApi.js.map